if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        if (!this.sectionId) return;

        this.liveRegion = this.querySelector(`#Recipient-fields-live-region-${this.sectionId}`);
        this.fieldsWrapper = this.querySelector(`#Recipient-fields-${this.sectionId}`) || this.querySelector('.recipient-fields');

        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.sectionId}`);
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.sectionId}`);

        this.emailInput = this.querySelector(`#Recipient-email-${this.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.sectionId}`);
        this.sendOnInput = this.querySelector(`#Recipient-send-on-${this.sectionId}`);

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessageHeader = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessageHeader?.innerText;

        if (this.checkboxInput) this.checkboxInput.disabled = false;
        if (this.hiddenControlField) this.hiddenControlField.disabled = true;
        this.setAttribute('data-js-enabled', 'true');

        // If the server returned values/errors, keep the form expanded.
        const hasPrefilledValue = this.inputFields().some((field) => field && String(field.value || '').trim() !== '');
        if (this.checkboxInput && hasPrefilledValue) this.checkboxInput.checked = true;

        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendOnInput].filter(Boolean);
      }

      disableableFields() {
        const fields = this.inputFields();
        if (this.offsetProperty) fields.push(this.offsetProperty);
        return fields;
      }

      onChange() {
        if (!this.checkboxInput) return;

        if (this.checkboxInput.checked) {
          this.expand();
        } else {
          this.collapse();
        }
      }

      expand() {
        if (this.fieldsWrapper) this.fieldsWrapper.hidden = false;
        if (this.checkboxInput) this.checkboxInput.setAttribute('aria-expanded', 'true');

        this.disableableFields().forEach((field) => (field.disabled = false));
        if (this.emailInput) this.emailInput.setAttribute('required', 'required');
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        if (this.liveRegion) this.liveRegion.innerText = this.dataset.expandedText || '';
      }

      collapse() {
        this.clearErrorMessage();

        // Clear input values so we don't submit stale properties.
        this.inputFields().forEach((field) => (field.value = ''));

        this.disableableFields().forEach((field) => (field.disabled = true));
        if (this.emailInput) this.emailInput.removeAttribute('required');
        if (this.offsetProperty) this.offsetProperty.value = '';

        if (this.fieldsWrapper) this.fieldsWrapper.hidden = true;
        if (this.checkboxInput) this.checkboxInput.setAttribute('aria-expanded', 'false');

        if (this.liveRegion) this.liveRegion.innerText = this.dataset.collapsedText || '';
      }

      clearErrorMessage() {
        if (this.errorMessageWrapper) this.errorMessageWrapper.hidden = true;
        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendOnInput].filter(Boolean).forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', 'false');
          inputElement.removeAttribute('aria-describedby');
        });

        if (this.errorMessageHeader && this.defaultErrorHeader) {
          this.errorMessageHeader.innerText = this.defaultErrorHeader;
        }
      }

      displayErrors(title, errors) {
        // Ensure form is expanded when displaying errors
        if (this.checkboxInput && !this.checkboxInput.checked) this.checkboxInput.checked = true;
        this.expand();

        if (this.errorMessageWrapper) this.errorMessageWrapper.hidden = false;
        if (this.errorMessageHeader) this.errorMessageHeader.innerText = title || this.defaultErrorHeader || '';
        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        if (!errors || typeof errors !== 'object') return;

        const inputMap = {
          email: this.emailInput,
          name: this.nameInput,
          message: this.messageInput,
          send_on: this.sendOnInput,
        };

        const selectorMap = {
          email: `#Recipient-email-${this.sectionId}`,
          name: `#Recipient-name-${this.sectionId}`,
          message: `#Recipient-message-${this.sectionId}`,
          send_on: `#Recipient-send-on-${this.sectionId}`,
        };

        Object.entries(errors).forEach(([key, value]) => {
          const message = Array.isArray(value) ? value.join(', ') : String(value);

          const errorMessageId = `RecipientForm-${key}-error-${this.sectionId}`;
          const fieldSelector = selectorMap[key] || `#Recipient-${key}-${this.sectionId}`;

          const errorMessageElement = this.querySelector(`#${errorMessageId}`);
          const errorTextElement = errorMessageElement?.querySelector('.error-message');
          if (errorTextElement) {
            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');
          }

          const inputElement = inputMap[key];
          if (inputElement) {
            inputElement.setAttribute('aria-invalid', 'true');
            inputElement.setAttribute('aria-describedby', errorMessageId);
          }

          if (this.errorMessageList) {
            const li = document.createElement('li');
            li.className = 'error-message';
            const a = document.createElement('a');
            a.setAttribute('href', fieldSelector);
            a.innerText = message;
            li.appendChild(a);
            this.errorMessageList.appendChild(li);
          }
        });
      }
    }
  );
}

